module.exports = __webpack_public_path__ + "img/default.37f922ae.png";